import { Injectable, Output, EventEmitter, TemplateRef } from '@angular/core';
import { ConfirmationdialogComponent } from "../confirmationdialog/confirmationdialog.component";
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ConfirmationdialogService {

  modalRef: BsModalRef;
  @Output() outputToParent = new EventEmitter();

  constructor(private modalService: BsModalService) { }

  // public confirm(
  //   title: string,
  //   message: string,
  //   btnOkText: string = 'OK',
  //   btnCancelText: string = 'Cancel',
  //   dialogSize: 'sm'|'lg' = 'sm'): Promise<boolean> {
  //   const modalRef = this.modalService.open(ConfirmationdialogComponent, { size: dialogSize });
  //   modalRef.componentInstance.title = title;
  //   modalRef.componentInstance.message = message;
  //   modalRef.componentInstance.btnOkText = btnOkText;
  //   modalRef.componentInstance.btnCancelText = btnCancelText;

  //   return modalRef.result;
  // }

  openModalWithClass(
    title: string,
    message: string,
    btnOkText: string,
    btnCancelText: string,
    dialogSize: 'sm' | 'lg' = 'lg'): Observable<any> {

    const initialState = { message: message, title: title, btnOkText: btnOkText, btnCancelText: btnCancelText };
    this.modalRef = this.modalService.show(
      ConfirmationdialogComponent,
      Object.assign({}, { class: 'gray modal-' + dialogSize, initialState })
    );

    // this.modalRef = this.modalService.show(
    //   ConfirmationdialogComponent, { initialState });

    this.modalRef.content.closeBtnName = 'Close';

    //  this.modalRef.content.action.subscribe((value) => {
    //               this.outputToParent.emit(true);
    //               // retVal = value;
    //               return value;
    //             }, 
    //               (err) => {
    //               console.log(err) 
    //               return false;
    //       });
    // return   this.modalRef.content;

    return new Observable<boolean>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.modalService.onHidden.subscribe((reason: boolean) => {
        observer.next(this.modalRef.content.answer);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }

}
